import { Flex, Box, Spacer, Text, Heading, Image } from "@chakra-ui/react";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getPoliticiansSearchRes,
  getGovernmentsSearchRes,
  getPoliticalPartiesSearchRes,
} from "../../../redux/actions/data/DataActions";
import { RootStore } from "../../../redux/Store";
import GovernmentCard from "../Home/GovernmentCard";
import PoliticalPartyCard from "../Home/PoliticalPartyCard";
import PoliticianCard from "../Home/PoliticianCard";

function MainHeading({ TopHeading }: HeadingProps) {
  return (
    <>
      <Flex as="body" align="center" justify="space-between" wrap="wrap">
        <Box p="1">
          <Text fontSize="xl" fontWeight="bold">
            {TopHeading}
          </Text>
          <Spacer />
        </Box>
      </Flex>
    </>
  );
}

function Search() {
  const param: { keyword: string } = useParams();
  const dataState = useSelector((state: RootStore) => state.data);
  const government = dataState.govSearchRes?.governments;
  const politicalParty = dataState.politicalPartiesSearchRes?.politicalParties;
  const politicians = dataState.politiciansSearchRes?.politicians;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPoliticiansSearchRes(param.keyword));
    dispatch(getGovernmentsSearchRes(param.keyword));
    dispatch(getPoliticalPartiesSearchRes(param.keyword));
  }, [param.keyword]);

  let checkData = false;
  if (
    (government?.length === 0 &&
      politicians?.length === 0 &&
      politicalParty?.length === 0) ||
    (!government && !politicians && !politicalParty)
  ) {
    checkData = false;
  } else {
    checkData = true;
  }

  const govAvgRating = (gov: IgovernmentData): number => {
    let avgRating: number = 0;

    const govReview = gov.reviews;
    for (let i = 0; i < Number(govReview?.length); i++) {
      if (govReview != undefined) {
        avgRating += Number(govReview[i].rating);
      }
    }
    if (Number(govReview?.length)) {
      return avgRating / Number(govReview?.length);
    }
    return 0;
  };
  const partyAvgRating = (party: IpoliticalPartyData): number => {
    let avgRating: number = 0;

    const partyReview = party.reviews;
    for (let i = 0; i < Number(partyReview?.length); i++) {
      if (partyReview != undefined) {
        avgRating += Number(partyReview[i].rating);
      }
    }
    if (Number(partyReview?.length)) {
      return avgRating / Number(partyReview?.length);
    }
    return 0;
  };
  const politicianAvgRating = (politician: IpoliticiansData): number => {
    let avgRating: number = 0;

    const politicianReview = politician.reviews;
    for (let i = 0; i < Number(politicianReview?.length); i++) {
      if (politicianReview != undefined) {
        avgRating += Number(politicianReview[i].rating);
      }
    }
    if (Number(politicianReview?.length)) {
      return avgRating / Number(politicianReview?.length);
    }
    return 0;
  };
  //-------------------------------For ui state-------------------------------

  return (
    <>
      {!checkData ? (
        <Box p="1" alignItems="center">
          <Image
            height="auto"
            width="70%"
            objectFit="cover"
            src="/nodata.png"
            alt="No Data"
            margin="auto"
            style={{
              marginBlock: "60px",
            }}
          />
          <Spacer />
        </Box>
      ) : (
        <>
          <Box id="MainSearchResultBox">
            <Heading as="h3">{"Search results for " + param.keyword}</Heading>
            <Spacer />
          </Box>
          {government?.length ? (
            <>
              <MainHeading TopHeading="Governments" />

              <div
                className="row"
                id="governmentRow"
                style={{
                  margin: "auto",
                  justifyContent: "space-evenly",
                }}
              >
                <>
                  {government?.map((gov) => (
                    <GovernmentCard
                      _id={String(gov._id)}
                      image={String(gov.image)}
                      status={String(gov.status)}
                      country={String(gov?.majority?.country?.name)}
                      description={String(gov.description)}
                      manOnIncharge={String(gov.manOnIncharge)}
                      reviewCount={gov.reviews?.length}
                      rating={govAvgRating(gov)}
                    />
                  ))}
                </>
              </div>
            </>
          ) : (
            <></>
          )}
          {politicalParty?.length ? (
            <>
              <MainHeading TopHeading="Political Parties" />

              <div
                className="row"
                id="politicalPartyRow"
                style={{
                  margin: "auto",
                  justifyContent: "space-evenly",
                }}
              >
                {politicalParty && (
                  <>
                    {politicalParty?.map((party) => (
                      <PoliticalPartyCard
                        _id={String(party._id)}
                        image={String(party.image)}
                        name={String(party.name)}
                        description={String(party.description)}
                        isGoverning={String(party.isGoverning)}
                        country={String(party?.country?.name)}
                        reviewCount={party.reviews?.length}
                        rating={partyAvgRating(party)}
                      />
                    ))}
                  </>
                )}
              </div>
            </>
          ) : (
            <></>
          )}
          {politicians?.length ? (
            <>
              <MainHeading TopHeading="Politicians" />
              <div
                className="row"
                id="politicianRow"
                style={{
                  margin: "auto",
                  justifyContent: "space-evenly",
                }}
              >
                <>
                  {politicians?.map((politician) => (
                    <PoliticianCard
                      _id={politician._id}
                      name={politician.name}
                      details={politician.details}
                      country={politician?.politicalParty?.country?.name}
                      image={politician.image}
                      reviewCount={politician.reviews?.length}
                      politicalParty={politician?.politicalParty?.name}
                      rating={politicianAvgRating(politician)}
                    />
                  ))}
                </>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
}

export default Search;
